module.exports = __webpack_public_path__ + "static/media/testAmountTitle.a9f282c0.png";